module.exports = "img/element-icons/room/default_app.79b63ba.svg";